import React from 'react';
import ReactGA from 'react-ga';
import { Redirect, Switch, useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { privateRoutes, publicRoutes } from './routes';
import { mapPrivateRoutes, mapPublicRoutes } from './utils';
import { useAuth } from './utils/hooks/auth';
import { routePaths } from './routePaths';
import { PrivateRouteLayout, PublicRouteLayout } from './layout';

const Main = () => {
    const { user } = useAuth();
    const history = useHistory();

    history.listen(location => {
        ReactGA.pageview(`${location.pathname}${location.search}`);
    });

    const LayoutElement = user ? PrivateRouteLayout : PublicRouteLayout;
    return (
        <>
            <Helmet defaultTitle='Immerly' titleTemplate="%s | Immerly"></Helmet>
            <LayoutElement>
                <Switch>
                    {mapPublicRoutes(publicRoutes)}
                    {mapPrivateRoutes(privateRoutes)}
                    <Redirect to={user ? routePaths.dashboard : routePaths.login} />
                </Switch>
            </LayoutElement>
        </>
    );
};

export default Main;
